import { useCallback, useMemo, useState } from "react";

export type DelayBase = 100 | 200;

export function useDelayBuckets<T extends { definitionId: number; latitude?: number; longitude?: number }>(
  points: T[],
  initialBase: DelayBase = 100
) {
  const [selectedDelayBase, setSelectedDelayBase] = useState<DelayBase>(initialBase);
  const [visible, setVisible] = useState({ 1: true, 2: true, 3: true, 4: true });

  const bucketOf = useCallback((p: T): 0 | 1 | 2 | 3 | 4 => {
    const codeEnding = Number(p.definitionId) - Number(selectedDelayBase);
    return codeEnding >= 1 && codeEnding <= 4 ? (codeEnding as 1 | 2 | 3 | 4) : 0;
  }, [selectedDelayBase]);

  const filtered = useMemo(() => {
    return (points ?? []).filter(p => {
      if (p.latitude == null || p.longitude == null) return false;
      const b = bucketOf(p);
      if (b === 0) return false;
      return visible[b as 1|2|3|4];
    });
  }, [points, bucketOf, visible]);

  return {
    selectedDelayBase,
    setSelectedDelayBase,
    visible,
    setVisible,
    bucketOf,
    filtered,
  };
}
